import BaseService from '@/services/base_service';

export default class CityService extends BaseService {
    list(params) {
        return new Promise((resolve, reject) => {
            axios.get('/cidade', params).then(response => {
                resolve(response);
            }).catch(e => {
                reject(e);
            });
        });
    }
}



// WEBPACK FOOTER //
// ./src/services/city.js